import { ff } from '@atlassian/jira-feature-flagging';

export const isItsmAgniAddedAttributeToLinkedIssueAddedEventEnabled = () =>
	ff('itsm-agni-added-attribute-to-linkedissue-added-event', false);
